import React from 'react';
import { AudienceSectionIcon } from 'taboola-ultimate-ui';
import { AudienceTargetingFirstCampaignIndication } from 'modules/campaigns/modules/common-campaign-form/components/AudienceTargetingSectionLegacy/AudienceTargetingFirstCampaignIndication';
import MarketplaceAudiencesField from 'modules/campaigns/modules/common-campaign-form/components/MarketplaceAudiences/MarketplaceAudiencesField';
import { MyAudiencesField } from 'modules/campaigns/modules/common-campaign-form/components/MyAudiencesField/MyAudiencesField';
import { AudienceTargetingTooltip } from './AudienceTargetingTooltip';
import { SegmentsTargetingSection } from './SegmentsTargetingSection';

export const AudienceTargetingSection = ({ isInitiallyCollapsed }) => {
    return (
        <SegmentsTargetingSection
            sectionId="CAMPAIGN_AUDIENCE_TARGETING"
            titleMessageId="campaign.editor.audience.targeting"
            descriptionMessageId="campaign.editor.audience.targeting.description"
            isShowTooltip
            tooltip={<AudienceTargetingTooltip />}
            headerIcon={<AudienceSectionIcon />}
            indication={<AudienceTargetingFirstCampaignIndication />}
            isInitiallyCollapsed={isInitiallyCollapsed}
        >
            <MarketplaceAudiencesField />
            <MyAudiencesField />
        </SegmentsTargetingSection>
    );
};
